export const PACKAGES = [
  {
    id: "meg-3",
    title: "3 Days Meghalaya Glimpse",
    days: 3,
    nights: 2,
    price: 14999,
    cover: "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=1600&q=80",
    places: ["Shillong", "Cherrapunji", "Dawki"],
    inclusions: ["Hotel stay", "Breakfast", "SUV transfers", "Sightseeing"],
  },
  {
    id: "meg-5",
    title: "5 Days Meghalaya Classic",
    days: 5,
    nights: 4,
    price: 24999,
    cover: "https://images.unsplash.com/photo-1742494267580-e026d3737f65?w=1600&q=80",
    places: ["Shillong", "Cherrapunji", "Mawlynnong", "Dawki", "Nongriat"],
    inclusions: ["Boutique stay", "All meals", "SUV", "Guide", "Permits"],
  },
  {
    id: "meg-assam-7",
    title: "7 Days Meghalaya + Assam",
    days: 7,
    nights: 6,
    price: 36999,
    cover: "https://images.unsplash.com/photo-1549366021-9f761d450615?w=1600&q=80",
    places: ["Guwahati", "Shillong", "Cherrapunji", "Kaziranga"],
    inclusions: ["4★ stays", "All meals", "Jeep safari", "Guides", "Permits"],
  },
  {
    id: "ne-10",
    title: "10 Days North East Explorer",
    days: 10,
    nights: 9,
    price: 58999,
    cover: "https://images.unsplash.com/photo-1628443266300-e8490ee38875?w=1600&q=80",
    places: ["Guwahati", "Kaziranga", "Shillong", "Cherrapunji", "Tawang"],
    inclusions: ["Premium stays", "All meals", "Inner-line permits", "Pro guide"],
  },
  {
    id: "ne-15",
    title: "15 Days Complete North East",
    days: 15,
    nights: 14,
    price: 92999,
    cover: "https://images.unsplash.com/photo-1621617249658-f7541ef42a93?w=1600&q=80",
    places: ["Assam", "Meghalaya", "Arunachal", "Nagaland touch"],
    inclusions: ["Luxury lodges", "All meals", "Permits", "Private SUV", "Lead guide"],
  },
];

export const FAQS = [
  {
    q: "When is the best time to visit Meghalaya?",
    a: "October through May for clear skies, waterfalls and root-bridge treks. June–September is monsoon — dramatic but wet.",
  },
  {
    q: "Is Dawki safe to visit?",
    a: "Yes. Dawki and Shnongpdeng are tourist-friendly with regular boating and camping operations. We use vetted local boatmen.",
  },
  {
    q: "Do you provide airport pickup?",
    a: "Yes — all our packages include private SUV pickup from Guwahati or Shillong airport with a curated welcome.",
  },
  {
    q: "Can the itinerary be customized?",
    a: "Absolutely. Use our 'Design Your Dream Trip' form — we craft every itinerary from scratch around your dates, budget and pace.",
  },
  {
    q: "Do I need permits for Arunachal Pradesh?",
    a: "Indian nationals need an Inner Line Permit; foreign nationals need a Protected Area Permit. We arrange both for you.",
  },
];

export const WHY_RANDZ = [
  { title: "Local Meghalaya Experts", desc: "Shillong-based team, born in these hills.", icon: "Compass" },
  { title: "Personalized Itineraries", desc: "Every trip is built around you — your pace, taste, dates.", icon: "Map" },
  { title: "Transparent Pricing", desc: "No hidden costs. Every rupee is on the invoice.", icon: "BadgeIndianRupee" },
  { title: "Comfortable Transport", desc: "Well-maintained SUVs and tempo travellers, experienced drivers.", icon: "Car" },
  { title: "Trusted Accommodation Partners", desc: "Hand-picked stays — homestays to boutique hotels.", icon: "BedDouble" },
  { title: "24 × 7 Travel Assistance", desc: "On-call support from a real human, any hour.", icon: "Headphones" },
];

export const GALLERY_IMAGES = [
  "https://images.unsplash.com/photo-1602020277972-fd160de66021?w=1200&q=80",
  "https://images.unsplash.com/photo-1592450620607-efefef574bd0?w=1200&q=80",
  "https://images.unsplash.com/photo-1616997865668-97bb97499459?w=1200&q=80",
  "https://images.unsplash.com/photo-1742494267580-e026d3737f65?w=1200&q=80",
  "https://images.unsplash.com/photo-1621617249658-f7541ef42a93?w=1200&q=80",
  "https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?w=1200&q=80",
  "https://images.unsplash.com/photo-1626621934130-58def2dbd4d2?w=1200&q=80",
  "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=1200&q=80",
  "https://images.unsplash.com/photo-1611042553484-d61f84d22784?w=1200&q=80",
  "https://images.unsplash.com/photo-1518627005462-a3eb2cd34504?w=1200&q=80",
  "https://images.unsplash.com/photo-1535338454770-8be927b5a00b?w=1200&q=80",
  "https://images.unsplash.com/photo-1601200351837-87d31f7a8d76?w=1200&q=80",
];

// Instagram-ready placeholder posts — replace with live feed once Meta token added
export const INSTAGRAM_POSTS = [
  { id: 1, image: "https://images.unsplash.com/photo-1742494267580-e026d3737f65?w=800&q=80", caption: "Living root bridges, Nongriat" },
  { id: 2, image: "https://images.unsplash.com/photo-1626621934130-58def2dbd4d2?w=800&q=80", caption: "Glass waters of Dawki" },
  { id: 3, image: "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=800&q=80", caption: "Sohra waterfalls" },
  { id: 4, image: "https://images.unsplash.com/photo-1611042553484-d61f84d22784?w=800&q=80", caption: "Shillong mornings" },
  { id: 5, image: "https://images.unsplash.com/photo-1602020277972-fd160de66021?w=800&q=80", caption: "Tea gardens, Assam" },
  { id: 6, image: "https://images.unsplash.com/photo-1628443266300-e8490ee38875?w=800&q=80", caption: "Tawang at dawn" },
];
